import React from 'react';
// eslint-disable-next-line import/no-relative-parent-imports
import loadingGif from './../../../images/loading.gif';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    message?: string;
    active: boolean;
}

const Loading = observer('Loading', (props: PropsType) => {
    const { active, message } = props;

    let loadingClass = 'loading-overlay';

    if (active) {
        loadingClass += ' visible';
    }

    return (
        <div className={loadingClass}>
            <div className='loading'>
                <img
                    src={loadingGif}
                    alt='spinner'
                />
            </div>
            <div className='loading-message'>{message}</div>
        </div>
    );
});

// eslint-disable-next-line import/no-default-export
export default Loading;
